<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.general_config">
  <app-popup-header
    title="{{localService.languageContent.general_config['header_'+configType] == undefined ? localService.languageContent.general_config['header_0'] : localService.languageContent.general_config['header_'+configType]}}"></app-popup-header>
  <div class="modal-body" *ngIf="wrapper != undefined" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-4">
        <input autocomplete="off" type="number" class="number"
          (keypress)="localService.isNumberOnly($event,numericConfig)"
          [ngClass]="wrapper.content.v2 != null ? 'en' : ''" [(ngModel)]="wrapper.content.v2"
          placeholder="{{localService.languageContent.general_config.enum_value}}"
          title="{{localService.languageContent.general_config.enum_value}}" />
      </div>
      <div class="col-8">
        <input autocomplete="off" type="text" [ngClass]="wrapper.content.v3 != '' ? 'en' : ''"
          [(ngModel)]="wrapper.content.v3" placeholder="{{localService.languageContent.general_config.config_code}}"
          title="{{localService.languageContent.general_config.config_code}}" />
      </div>
    </div>
    <app-language-container [(languageContents)]="wrapper.languageContents" [IsNeedNewLine]="true"
      [IsLargeText]="isLargeText" (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)"
      [IsShowAllLanguages]="true" [IsAllMandatory]="true"></app-language-container>
  </div>
  <div class="modal-footer modal_footer_message" *ngIf="message != ''">
    <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary"
      (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>